import { render, staticRenderFns } from "./Whatsappaudio.vue?vue&type=template&id=168a03e7&"
import script from "./Whatsappaudio.vue?vue&type=script&lang=js&"
export * from "./Whatsappaudio.vue?vue&type=script&lang=js&"
import style0 from "./Whatsappaudio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports